export enum RequestState {
    SAVED = 'saved',
    SUBMITTED = 'submitted',
    PENDING_CUSTOMER_ACTION = 'pending-customer-action',
    REFERRED_OUT = 'referred-out',
    UNDER_REVIEW = 'under-review',
    CLOSED = 'closed'
}

//Condtions are counted from top (1) to bottom (4)
export enum RequestStateCondition {
    CONDITION_1 = 'conditionNode1',
    CONDITION_2 = 'conditionNode2',
    CONDITION_3 = 'conditionNode3',
    CONDITION_4 = 'conditionNode4'
}

export enum RequestStateConnection {
    SUBMITTED_TO_CONDITION_1 = 'submittedToCondition1',
    CONDITION_1_TO_UNDER_REVIEW = 'condition1ToUnderReview',
    CONDITION_2_TO_UNDER_REVIEW = 'condition2ToUnderReview',
    CONDITION_2_TO_SUBMITTED = 'condition2ToSubmitted',
    CONDITION_2_TO_REFERRED_OUT = 'condition2ToReferredOut',
    CONDITION_2_TO_PENDING_CUSTOMER_ACTION = 'condition2ToPendingCustomerAction',
    CONDITION_2_TO_RESOLVED = 'condition2ToResolved',
    CONDITION_3_TO_UNDER_REVIEW = 'condition3ToUnderReview',
    CONDITION_3_TO_CLOSED = 'condition3ToResolved',
    CONDITION_3_PENDING_CUSTOMER_ACTION = 'condition3ToPendingCustomerAction',
    CONDITION_4_TO_UNDER_REVIEW = 'condition4ToUnderReview',
    CONDITION_4_TO_REFERRED_OUT = 'condition4ToReferredOut',
    UNDER_REVIEW_TO_CONDITION_2 = 'underReviewToCondition2',
    PENDING_CUSTOMER_ACTION_TO_CONDITION_4 = 'PendingCustomerActionToCondition4',
    REFERRED_OUT_TO_CONDITION_3 = 'referredOutToCondition3'
}
